import TablePager from './TablePager';

export default TablePager;
